import { render } from "./PeriodSelectionComponent.vue?vue&type=template&id=210f191a&scoped=true"
import script from "./PeriodSelectionComponent.vue?vue&type=script&lang=js"
export * from "./PeriodSelectionComponent.vue?vue&type=script&lang=js"

import "./PeriodSelectionComponent.vue?vue&type=style&index=0&id=210f191a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210f191a"]])

export default __exports__